import { useQueryClient } from '@tanstack/react-query'
import { InputNumber } from 'antd'
import ModalStyledLoader from 'components/Elements/ModalStyledLoader'
import SectionTitle from 'components/SectionTitle'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import axiosClient, { updateBook } from 'services/axios-client'
import { useBookQuery } from 'store/queries'
import PromptFreqContainer from './style'

const PromptFreq = () => {
  const { t } = useTranslation()
  const { bookId } = useParams()
  const queryClient = useQueryClient()

  const [promptFreq, setPromptFreq] = useState(1)
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')
  const { data: book } = useBookQuery(bookId)

  useEffect(() => {
    setPromptFreq(book.prompt_frequency)
  }, [book.prompt_frequency])

  useEffect(() => {
    if (!book.has_checked_prompt_freq) {
      axiosClient
        .patch(`/book/${bookId}`, {
          has_checked_prompt_freq: true,
        })
        .then((res) => {
          if (res.ok) {
            queryClient.invalidateQueries({ queryKey: ['book', bookId] })
          }
        })
    }
  }, [bookId, book.has_checked_prompt_freq, queryClient])

  const saveFreq = async () => {
    setError('')
    setIsSaving(true)
    const result = await updateBook(bookId, {
      prompt_frequency: promptFreq,
    })

    if (result.ok) {
      queryClient.invalidateQueries({ queryKey: ['book', bookId] })
    } else {
      setError(
        result?.data?.message ||
          'Unable to update prompt frequency. Please try again.',
      )
    }

    setIsSaving(false)
  }

  return (
    <PromptFreqContainer>
      <div className="edit-container modal-custom-body p20 section-container">
        <SectionTitle className="mt1rem">Edit Prompt Frequency</SectionTitle>

        {!book.id || isSaving ? (
          <div data-testid="prompt-freq-updating">
            <ModalStyledLoader />
          </div>
        ) : (
          <div className="info-row">
            <div className="frequency">
              <div className={`info-label`}>
                {t('send_new_story_prompt_every')}
              </div>
              <InputNumber
                data-testid="prompt-freq-input"
                size="large"
                min={1}
                value={promptFreq}
                onChange={(value) => setPromptFreq(value)}
                style={{ width: 60, marginLeft: 8, marginRight: 8 }}
              />
              <div className={`info-label`}>{t('days_update')}</div>
            </div>
          </div>
        )}

        {error && <div className="error-message">{error}</div>}
        <div className="save-section actions">
          <Button
            className="btn-blue btn-dash"
            onClick={saveFreq}
            disabled={
              isSaving || !promptFreq || promptFreq === book.prompt_frequency
            }
          >
            {t('save')}
          </Button>
        </div>
      </div>
    </PromptFreqContainer>
  )
}

export default PromptFreq
